<div class="container-fluid">
  <div>
    <div class="content">
      <div class="filters" *ngIf="!loading || filteredRentalAccessories.length > 0">
        <div>
          <div class="category-filter" *ngIf="categories.length > 0">
            <div>{{ 'bikeshop.rentals.products.category' | translate }}:</div>
            <div>
              <div *ngFor="let category of categories" class="filter-items"
                   (click)="selectCategoryFilter(category)"
                   [ngClass]="{'selected': category.accessoryCategoryID === selectedCategoryFilter.accessoryCategoryID}">
                <div><span class="fa"
                           [ngClass]="{ 'fa-minus-circle' : category.accessoryCategoryID === selectedCategoryFilter.accessoryCategoryID, 'fa-plus-circle' : category.accessoryCategoryID !== selectedCategoryFilter.accessoryCategoryID }"></span>{{category.categoryName}}
                </div>
              </div>
            </div>
          </div>
          <div class="brand-filter" *ngIf="brands.length > 0">
            <div>{{ 'bikeshop.rentals.products.brand' | translate }}:</div>
            <div>
              <div *ngFor="let brand of brands" class="filter-items" (click)="selectBrandFilter(brand)"
                   [ngClass]="{'selected': brand.brand === selectedBrandFilter.brand}">
                <div><span class="fa"
                           [ngClass]="{ 'fa-minus-circle' : brand.brand === selectedBrandFilter.brand, 'fa-plus-circle' : brand.brand !== selectedBrandFilter.brand }"></span>{{brand.brand}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-right">
          <div class="p-inputgroup" style="margin-left: 30px; width: 300px; float: left;">
            <input type="text" pInputText placeholder="{{ 'general.search' | translate }}"
                   (input)="setSearch($event.target['value'])"/>
            <span class="p-inputgroup-addon"><i class="hubtiger-search"></i></span>
          </div>
          <div class="margin-top-16" style="margin-bottom: -36px;">
            <button pButton (click)="addNewRentalAccessory()" class="ui-button-raised"
                    label="{{'bikeshop.rentals.products.add_new_accessory' | translate}}"
                    [disabled]="null"
                    style="width: 250px;"></button>
            <!--      todo: DC there is no "tiring"     -->
          </div>
        </div>
      </div>
      <div class="accessory-header">
        <div class="chevron"></div>
        <!-- <div class="avatar"></div> -->
        <div class="brand">{{ 'bikeshop.rentals.products.brand_name' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.category' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.quantity' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.sizes' | translate }}</div>
        <!-- <div class="spacer"></div> -->
        <div class="status-spacer"></div>
        <div class="action-spacer"></div>
      </div>
      <div *ngIf="loading && filteredRentalAccessories.length === 0"
           style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>
      <div *ngFor="let accessory of filteredRentalAccessories"
           [ngClass]="{'invalid': !isAccessoryComplete(accessory)}">
        <div class="accessory-row">
          <div class="indicator"
               [ngStyle]="{'background-color': '#'+intToRGB(hashCode(accessory.brand+' '+accessory.name))}"></div>
          <div class="chevron"><span class="fa" [ngClass]="{'fa-chevron-down': accessory.brand == expandedAccessory.brand
              && accessory.name == expandedAccessory.name
              && accessory.accessoryCategoryID == expandedAccessory.accessoryCategoryID,'fa-chevron-right': !(accessory.brand == expandedAccessory.brand
              && accessory.name == expandedAccessory.name
              && accessory.accessoryCategoryID == expandedAccessory.accessoryCategoryID)}"
                                     (click)="expandAccessory(accessory)"></span>
          </div>
          <!-- <div class="avatar"><avatar size=20 name="{{accessory.brand+' '+accessory.model}}" hideName="true"></avatar></div> -->
          <div class="brand">
            <div>{{accessory.brand}}/{{accessory.name}}</div>
          </div>
          <div class="category">{{accessory.categoryName}}</div>
          <div class="year">{{accessory.rentalAccessories.length}}</div>
          <div class="sizes">{{accessory.sizes.join(", ")}}</div>
          <!-- <div class="spacer"></div> -->
          <div class="status-spacer"></div>
          <div class="action-spacer"></div>
        </div>
        <div *ngIf="accessory.brand == expandedAccessory.brand
                    && accessory.name == expandedAccessory.name
                    && accessory.accessoryCategoryID == expandedAccessory.accessoryCategoryID"
             class="sub-accessory-container">
          <div class="sub-accessory-header">
            <div style="flex: 2;display: flex;">
              <div class="image">{{ 'bikeshop.rentals.products.image' | translate }}</div>
              <div class="identifier">{{ 'bikeshop.rentals.products.serial_number' | translate }}</div>
            </div>
            <div>{{ 'bikeshop.rentals.products.price_group' | translate }}</div>
            <div class="color">{{ 'bikeshop.rentals.products.color' | translate }}</div>
            <div>{{ 'bikeshop.rentals.products.size' | translate }}</div>
            <div class="status">{{ 'bikeshop.rentals.products.status' | translate }}</div>
            <div class="action"></div>
          </div>
          <div *ngFor="let item of accessory.rentalAccessories" class="sub-accessory-row">
            <div style="flex: 2; display: flex;">
              <div class="image">
                <div *ngIf="item.imageURL"><img [src]="item.imageURL"></div>
                <div *ngIf="!item.imageURL"><img
                  src="../../../../../../../../assets/no-product-image.png"></div>
              </div>
              <div class="identifier">
                <div>
                  <p-inplace #serialNumber>
                  <span pInplaceDisplay>
                    {{item.serialNumber}}
                  </span>
                    <span pInplaceContent>
                    <div class="ui-inputgroup">
                      <input pInputText type="text" [(ngModel)]="item.serialNumber"
                             (keyup.enter)="updateRecord(item, serialNumber)"
                             (blur)="updateRecord(item, serialNumber)"/>
                      <span class="ui-inputgroup-addon" (click)="updateRecord(item, serialNumber)"><i
                        class="fa fa-check"
                        [ngClass]="{ red: item.serialNumber && item.serialNumber.length > 0 }"></i></span>
                    </div>
                  </span>
                  </p-inplace>
                </div>
              </div>
            </div>
            <div>{{item.priceGroupName}}</div>
            <div class="color">
              <p-inplace #color>
              <span pInplaceDisplay>
                {{item.color}}
              </span>
                <span pInplaceContent>
                <div class="ui-inputgroup">
                  <input pInputText type="text" [(ngModel)]="item.color" (keyup.enter)="updateRecord(item, color)"
                         (blur)="updateRecord(item, serialNumber)"/>
                  <span class="ui-inputgroup-addon" (click)="updateRecord(item, color)"><i class="fa fa-check"
                                                                                           [ngClass]="{ red: item.color && item.color.length > 0 }"></i></span>
                </div>
              </span>
              </p-inplace>
            </div>
            <div>{{item.size}}</div>
            <div class="status">
              <div [ngClass]="{'available': item.statusID === 10, 'repair': item.statusID === 40}"><span
                class="fa fa-circle"></span>{{item.status}}
              </div>
            </div>
            <div class="action">
              <span class="fa hubtiger-edit" (click)="editAccessory(item)"></span>
              <span class="fa fa-clone" (click)="cloneAccessory(item)"></span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!loading && rentalAccessories.length === 0" class="no-accessories">
        {{ 'bikeshop.rentals.accessories.no_accessories' | translate }}
      </div>
    </div>
  </div>

  <p-sidebar #NavSideBar [(visible)]="showRentalAccessory" position="right" [autoZIndex]="false"
             [baseZIndex]="0"
             [showCloseIcon]="false"
             [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto', 'z-index': '1001'}"
             (onHide)="getRentalAccessories(); NavSideBar.destroyModal()">
    <div *ngIf="showRentalAccessory">
      <app-add-edit-rental-accessory [accessory]="selectedAccessory" [cloneAccessory]="isCloneAccessory"
                                     [messageService]="messageService"
                                     (close)="closeRentalAccessory()"></app-add-edit-rental-accessory>
    </div>
  </p-sidebar>
  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
</div>
